import React, {Component} from 'react';
import { connect } from 'react-redux';
import Header from '../base/header';
import RadioGroup from '../base/radiogroup';
import Cta from '../base/cta';
import api from '../../utils/api';
import {InfoBox, GoogleMap, MarkerClusterer, Marker, Polygon, StyledMapWithAnInfoBox, Wkt} from '../base/map';

class Map extends Component {

    constructor(props) {
      super(props);
      this.state = {
        loader: ' loader-box',
        flags: [],
        markers: [],
        polygons: [],
        filteredMarkers: [],
        loadMap: false,
        currentMarker: {}
      };
      this.getFlag = this.getFlag.bind(this);
      this.processState = this.processState.bind(this);
      this.mapRender = this.mapRender.bind(this);
    }

    mapRender(props) {
      let _self = this;
      if (props.loadMap) {
        return <GoogleMap defaultOptions={{ styles: props.myStyle }} defaultZoom={props.zoom} defaultCenter={{ lat: props.center.lat, lng: props.center.lng }}>
          {props.polygons}
          {props.markers && props.markers.length && <MarkerClusterer averageCenter enableRetinaIcons gridSize={120}>
            {props.markers.map(station => {
              return <Marker key={station.id} icon={{url: api.marker(station.brand.map_marker)}} position={{ lat: parseFloat(station.latitude), lng: parseFloat(station.longitude) }} onClick={ () => { _self.setState({ currentMarker: station }); } }>
                {_self.state.currentMarker.id === station.id && <InfoBox onCloseClick={ () => { _self.setState({ currentMarker: {} }); } } options={{ closeBoxURL: ``, enableEventPropagation: true }}>
                    <div className="info-box">
                      <h2>{station.brand.name.toLowerCase().includes('shell') ? ('Shell ' + station.global_code + ' (' + station.inscription_number + ')') : station.brand.name + " " + station.inscription_number}<span onClick={ () => { _self.setState({ currentMarker: {} }); } }>X</span></h2>
                      <p>{station.address}</p>
                      <p className="mb-2">{station.company.cuit}</p>
                      {station.last_prices.map(price => {
                        return <p key={price.product_shortname}>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
                      })}
                    </div>
                  </InfoBox>
                }
              </Marker>
            })}
          </MarkerClusterer>}
        </GoogleMap>
      } else {
        return <div></div>
      }
    }

    processState(isMount) {
      let _self = this;
      this.setState({
        loadMap: false,
        markers: [],
        polygons: []
      }, function() {
        let markers = [];
        let polygons = [];
        let flags = {};
        api.get('filters/brands').then(resp => {
          let brands = [];
          resp.data.forEach(brand => {
            brands.push('brand_list=' + brand.id);
          });
          api.get('map/?' + brands.join('&')).then(resp => {
            resp.data.clusters.map((cluster, index) => {
              let polygon = [];
              if (cluster.polygon) {
                let wkt = new Wkt.Wkt();
                wkt.read(cluster.polygon.split(';')[1]);
                wkt.toJson().coordinates[0][0].forEach(cord => {
                  polygon.push({ lat: cord[1], lng: cord[0] });
                });
              }
              return polygons.push(<Polygon key={cluster.id} path={polygon} />);
            });
            resp.data.stations.map((station,index) => {
              let key = 'OTRAS';
              if (station.brand.name.indexOf('SHELL') >= 0) key = 'SHELL';
              else if (station.brand.name.indexOf('YPF') >= 0) key = 'YPF';
              else if (station.brand.name.indexOf('AXION') >= 0) key = 'AXION';
              else if (station.brand.name.indexOf('PETROBRAS') >= 0) key = 'PETROBRAS';
              flags[key] = { id: station.brand.id, label: key, color: key.toLowerCase(), active: true };

              if (isMount) markers.push(station);
              else {
                let include = false;
                for (let i = 0; i < _self.state.flags.length; i++) {
                  if (_self.state.flags[i].active && _self.state.flags[i].label === key) {
                    include = true;
                    break;
                  }
                }
                if (include) markers.push(station);
              }
              return true;
            });
            
            let _flags = [];
            if (isMount) {
              Object.keys(flags).forEach(key => {
                _flags.push(flags[key]);
              })
            } else {
              _flags = JSON.parse(JSON.stringify(this.state.flags));
            }

            _self.setState({
              flags: _flags,
              markers: markers,
              polygons: polygons,
              loadMap: true,
              loader: ''
            }, function() {
              _self.refs.flags.update();
            });

          });
        });
      });
    }

    componentWillMount() {
      this.processState(true);
    }

    getFlag(item, removedItem) {
      let flags = JSON.parse(JSON.stringify(this.state.flags));
      flags.forEach((cluster, i) => {
        if (removedItem.id === flags.id)
          flags[i].active = item.length > 0;
      });
      this.setState({
        flags: flags
      }, function() {
        this.processState();
      });
    }

    render(){
      let _self = this;
      return <div className="map-page">
        <Header history={this.props.history} />
        <div className={this.state.loader}>
          <StyledMapWithAnInfoBox currentMarker={this.state.currentMarker} renderMethod={this.mapRender} polygons={this.state.polygons} markers={this.state.markers} loadMap={_self.state.loadMap} />
          <section className="map-lg">
            <div className="map-lg_controls">
              <div className="map-lg_controls_stations">
                <span className="list-title">Estaciones:</span>
                <RadioGroup ref="flags" text='VER:' items={this.state.flags}  getItem={this.getFlag} />
              </div>
              <div className="map-lg_controls_clusters">
                <span className="list-title">Clusters:</span>
                <Cta text="CREAR CLUSTER" className="font-small medium" plusIcon centered click={() => { window.location = '/analisis/cluster/nuevo' } } />
              </div>
            </div>
          </section>
        </div>
      </div>
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Map);



// WEBPACK FOOTER //
// ./src/containers/map/map.js